import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { CoreService } from '../services'

@Injectable({
  providedIn: 'root',
})
export class FileUtilService {
  constructor(
    private readonly translateService: TranslateService,
    private readonly core: CoreService,
  ) {}
  async processUploadedFileToBase64(file: any): Promise<string | any> {
    return new Promise((resolve, reject) => {
      if (file) {
        const reader = new FileReader()
        reader.readAsBinaryString(new Blob([file]))
        reader.onload = evt => {
          resolve({
            text: file.name,
            originalFilename: file.name,
            mimeType: file.type,
            base64Data: `data:application/octet-stream;base64,${btoa(String(evt?.target?.result))}`,
          })
        }
        reader.onerror = () => {
          reject(this.translateService.instant('file-util.file-processing-error'))
        }
      } else {
        reject(this.translateService.instant('no-file'))
      }
    })
  }

  async processDownloadedData(blob: Blob, file): Promise<string | any> {
    return new Promise((resolve, reject) => {
      if (file) {
        const reader = new FileReader()
        reader.onloadend = evt => {
          const filename = file.name || file.originalFilename || 'image'
          resolve({
            text: filename,
            originalFilename: filename,
            mimeType: file.mimeType || file.type || blob.type,
            base64Data: `data:application/octet-stream;base64,${btoa(String(evt?.target?.result))}`,
          })
        }
        reader.onerror = () => {
          reject(this.translateService.instant('file-util.file-processing-error'))
        }
        reader.readAsBinaryString(blob)
      } else {
        reject(this.translateService.instant('no-file'))
      }
    })
  }

  async downloadFile(url: string, fileName: string) {
    const blob = await this.core.services.http.downloadBlob(url)
    const objectUrl = window.URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    document.body.appendChild(anchor)
    anchor.href = objectUrl
    anchor.download = fileName
    anchor.click()
    window.URL.revokeObjectURL(objectUrl)
  }
}
